var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-toolbar",style:(`
      height:${_vm.height}px;
      padding-left:${_vm.gap}px;
      gap:${_vm.gap}px
      `)},[_vm._l((_vm.validItems),function(item,index){return [_c('ToolbarItem',_vm._b({key:item.key || 'key'+index,attrs:{"item-id":item.key,"height":_vm.height - 2*_vm.gap,"counts":_vm.counts,"gap":_vm.gap},on:{"on-event":_vm.handleEvent,"input":function($event){return _vm.$emit('input',$event)}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'ToolbarItem',item,false))]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }